export default __webpack_public_path__ + "static/media/cells.417bf05b.png";